import { Menu } from "@mui/material";
import { styled } from "@mui/material/styles";

interface Props {
  selectedColor?: string;
  hoverColor?: string;
}

export const StyledMenu = styled(Menu, {
  shouldForwardProp(propName) {
    return propName !== 'selectedColor' && propName !== 'hoverColor'
  },
})((props: Props) => ({
  "& .MuiPaper-root": {
    fontFamily: "Manrope !important",
    fontSize: 18,
    borderRadius: "12px",
    boxShadow: "0px 4px 10px rgba(15, 56, 104, 0.25)",
    minWidth: "180px",
    "& .MuiMenu-list": {
      fontSize: 18,
    },
    "& .MuiMenuItem-root": {
      padding: "8px 16px",
      font: "normal 400 12px/24px Manrope",
      "& svg": {
        fontSize: 18,
        marginRight: 25,
      },
    },
    "& .MuiMenuItem-root.Mui-selected": {
      backgroundColor: "#EDF5FB",
      color: props?.selectedColor || "#308CDB",
      fontWeight: 600,
    },
    "& .MuiMenuItem-root:hover": {
      backgroundColor: "#EDF5FB",
      color: props?.hoverColor || "#308CDB",
    },
  },
}));
